// Columns of the tables money moves through: operator invoices, affiliate agreements, the payment
// and bank settings, wallets, credits and voucher codes. A percentage says so in its name, because a
// reader cannot tell 5 from 5% once the column name is gone.
export const MONEY_COLUMN_LABELS: Record<string, string> = {
  AccountHolderName: "Mbajtësi i llogarisë",
  AccountNumber: "Numri i llogarisë",
  BankName: "Banka",
  BankAccountNumber: "Numri i llogarisë bankare",
  IBAN: "IBAN",
  SWIFT: "SWIFT",
  VAT: "Numri i TVSH-së",
  BusinessUniqueId: "Numri unik i biznesit",
  AgencyName: "Emri i agjencisë",
  Address: "Adresa",
  FiscalNumber: "Numri fiskal",
  HeadQuarters: "Selia",
  InvoiceRecipientEmails: "Email-at që marrin faturën",
  AutoInvoiceEmailEnabled: "Fatura dërgohet automatikisht",
  AffiliateName: "Emri i afiliatit",
  AffiliateCode: "Kodi i afiliatit",
  PromoCode: "Kodi promocional",
  AllowMultipleUses: "Lejon përdorime të shumta",
  ApplicationNote: "Shënimi i aplikimit",
  AdminNote: "Shënimi i adminit",
  ApprovedDate: "Miratuar më",
  SocialMediaUrl: "Rrjeti social",
  Website: "Faqja e internetit",
  BusTicketCommissionPercentage: "Komisioni për bileta (%)",
  BusTicketDiscountPercentage: "Zbritja për bileta (%)",
  EsimCommissionPercentage: "Komisioni për eSIM (%)",
  EsimDiscountPercentage: "Zbritja për eSIM (%)",
  TotalPrice: "Totali",
  TotalOperatorAmount: "Shuma e operatorit",
  TotalGjirafaCommission: "Komisioni i Gjirafës",
  TotalCancellations: "Totali i anulimeve",
  NetBillable: "Shuma neto për faturim",
  CancelledAtUtc: "Anuluar më",
  CancelledByUserId: "Anuluar nga",
  SentAtUtc: "Dërguar më",
  AppliedServiceFeePercentage: "Tarifa e shërbimit (%)",
  IncludedFee: "Tarifa e përfshirë",
  IsInternational: "Ndërkombëtar",
  PdfLink: "Lidhja e PDF-së",
  JourneyId: "Rezervimi",
  OneWayTicketId: "Bileta e vajtjes",
  RoundWayTicketId: "Bileta e kthimit",
  isFirstClass: "Klasi i parë",
  isSecondClass: "Klasi i dytë",
  NotWorking: "Jashtë funksionit",
  WalletId: "Portofoli",
  WalletTransactionId: "Transaksioni i portofolit",
  CreditsExpiryAtUtc: "Kreditë skadojnë më",
  LeaderboardAnonymousName: "Emri në renditje",
  LeaderboardNameMode: "Si shfaqet emri në renditje",
  DiscountRecieved: "Zbritja e marrë",
  IsUsed: "E përdorur",
  UsedAt: "Përdorur më",
  CreditAmount: "Shuma e kredive",
  LockedToEmail: "I lidhur me email-in",
  AssignedToEmail: "Caktuar për email-in",
  AssignedAtUtc: "Caktuar më",
  Campaign: "Fushata"
};
